import { useState, useMemo, useCallback } from 'react';
import { SORT_DIRECTION } from './constants';

export const useTableData = (initialData = [], options = {}) => {
    const [sortConfig, setSortConfig] = useState({
        key: null,
        direction: SORT_DIRECTION.NONE
    });

    const [filterQuery, setFilterQuery] = useState('');

    const handleSort = useCallback((key) => {
        setSortConfig(prev => {
            if (prev.key === key) {
                if (prev.direction === SORT_DIRECTION.ASC) return { key, direction: SORT_DIRECTION.DESC };
                if (prev.direction === SORT_DIRECTION.DESC) return { key: null, direction: SORT_DIRECTION.NONE };
            }
            return { key, direction: SORT_DIRECTION.ASC };
        });
    }, []);

    const filteredAndSortedData = useMemo(() => {
        let items = [...initialData];

        // 1. Filtering
        if (filterQuery) {
            const query = filterQuery.toLowerCase();
            items = items.filter(item => 
                Object.values(item).some(val => 
                    String(val).toLowerCase().includes(query)
                )
            );
        }

        // 2. Sorting
        if (sortConfig.key && sortConfig.direction !== SORT_DIRECTION.NONE) {
            items.sort((a, b) => {
                const aVal = a[sortConfig.key];
                const bVal = b[sortConfig.key];

                if (aVal === bVal) return 0;
                
                const factor = sortConfig.direction === SORT_DIRECTION.ASC ? 1 : -1;
                
                if (typeof aVal === 'number' && typeof bVal === 'number') {
                    return (aVal - bVal) * factor;
                }
                
                return String(aVal).localeCompare(String(bVal)) * factor;
            });
        }

        return items;
    }, [initialData, sortConfig, filterQuery]);

    return {
        data: filteredAndSortedData,
        sortConfig,
        handleSort,
        setFilterQuery,
        filterQuery
    };
};
